module.exports = __webpack_public_path__ + "img/12ced58.jpg";